import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DC','DE','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
  'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
  'VT','VA','WA','WV','WI','WY',
];

export default function AddClientPage() {
  const { addClient, user } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: '', domicileState: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isFirstClient = !user?.clients?.length;

  function updateField(field: string, value: string) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await addClient({
        name: form.name,
        domicileState: form.domicileState,
      });
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to create client.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={isFirstClient ? 'min-h-screen bg-ivory-100 flex items-center justify-center px-8' : ''}>
      <div className={isFirstClient ? 'w-full max-w-lg' : 'card max-w-lg'}>
        {isFirstClient && (
          <div className="mb-8">
            <h1 className="font-display text-display-lg text-navy-900 mb-2">
              Welcome to Osprey Legacy
            </h1>
            <p className="text-sm text-navy-400 font-sans">
              Add your first family office client to get started with capital planning and estate strategy.
            </p>
          </div>
        )}

        {!isFirstClient && (
          <h2 className="card-header">Add Client</h2>
        )}

        {error && (
          <div className="mb-6 p-3 bg-burgundy-50 border border-burgundy-200 rounded-md">
            <p className="text-sm text-burgundy-600 font-sans">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="input-label">Family Office Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => updateField('name', e.target.value)}
              className="input"
              placeholder="e.g. The Smith Family Office"
              required
              autoFocus
            />
          </div>

          <div>
            <label className="input-label">Domicile State</label>
            <select
              value={form.domicileState}
              onChange={(e) => updateField('domicileState', e.target.value)}
              className="input"
              required
            >
              <option value="">Select state...</option>
              {US_STATES.map((st) => (
                <option key={st} value={st}>{st}</option>
              ))}
            </select>
          </div>

          <button type="submit" disabled={isLoading} className="btn-primary w-full">
            {isLoading ? 'Creating...' : isFirstClient ? 'Add Client & Get Started' : 'Add Client'}
          </button>
        </form>
      </div>
    </div>
  );
}
